import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-student-classroom-navbar',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './student-classroom-navbar.component.html',
  styleUrl: './student-classroom-navbar.component.scss'
})
export class StudentClassroomNavbarComponent {

}
